module.exports = __webpack_public_path__ + "static/img/mail_icon_3.da760e54.svg";